import { createGlobalStyle } from 'styled-components'
import { CSS_RESET } from './cssReset'
import { StyleOverride } from './styleOverride'

export const GlobalStyleOverride = createGlobalStyle`
  ${CSS_RESET}
  ${StyleOverride}
`
